import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;

  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Kinos provide a wide spectrum of technical advice about buildings and building,
          </h3>
          <p>
             covering every aspect of assessing, developing, occupying, maintaining and adapting real estate assets of every type.
          </p><p>
We work closely with our clients throughout each assignment, listening to what you want to achieve and frequently finding new or innovative ways to deliver. For complex assignments, we create and lead effective project teams, working closely with our own colleagues as well as with external consultants. This combination of broadly based skill with the richness of our experience ensures you always see the complete picture and can make fully informed decisions.
</p><p>
Business Development & Strategic advice
</p><p>
We can assist in the analysis of any real estate portfolio. We can lead functions such as interim assignments and provide strategic advice where necessary. We can be your project development unit from concept to delivery.
</p><p>
Returns take priority. Quick and sound advice
These factors are essential to the decision-making processes for sales and acquisition transactions, lease contract service provisions, sustainability issues and the optimisation of a property’s features.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured= {featured} url="building" />
          <SectionRecents recents={recents} url="building" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8}   id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
